<div class="ttmodal" [style]="setWindowPosition(positionX, positionY)" id="schematicmasterWindow">
  <div id="schematicWindowHeader_" class="ttmodal__header" >
      <span class="ttmodal__title" style="margin-top: 18px;margin-left: 25px;">Schematic and Observation Point</span>
      <div class="panel__header__button-container">
      </div>
  </div>

  <div class="ttmodal__body">
      <div style="display: flex;flex-direction: row;justify-content: flex-start">

<!-- edit observation point details-->

<div class="ttmodal" id="observationWindow" >
    <div id="observationWindowHeader" class="ttmodal__header">
      <span class="ttmodal__title" style="margin-left: 40px;">Edit Observation Point</span>
      <div class="panel__header__button-container">
  
      </div>
    </div>
    <div class="ttmodal__body">
      <div style="width: 620px; height: 550px;margin-left: 30px;">
        <div style="display: flex; flex-direction: row;">
          <span style="align-self: center;min-width: 102px;">Name</span>
  
          <mat-form-field style="    width: 56%">
            <input matInput placeholder="Observation Name" type="text"
                [(ngModel)]="Compname" ngDefaultControl required >
        </mat-form-field>
        </div>
  
        <ng-container *ngFor="let cp of findEditObsPoint">
            <ng-container *ngIf="cp.ObservationType == 'Crack'">

        <div style="display: flex; flex-direction: row;" >
          <span  style="align-self: center;min-width: 102px;">Click pencil, then specific Point in image to Create Crack Start Point then confirm with tick box</span>
          <a (click)="ClearCurrentStartXY()"><i class="material-icons square-button__icon" style="cursor: pointer;">edit</i></a>
          <mat-form-field style="width: 20%;">
            <input matInput type="text"[(ngModel)]="startXY"  #noOfReading_="ngModel" [disabled]="true">
          </mat-form-field>
          <a  *ngIf="isStartEdit==false"><i class="material-icons square-button__icon"  title="Confirm Starting Point" style="cursor: pointer;">check_box</i></a>
          <a (click)="ConfirmStartXY()" *ngIf="isStartEdit==true"><i class="material-icons square-button__icon"  title="Confirm Starting Point" style="cursor: pointer;">check_box_outline_blank</i></a>
        </div>
  
        <div style="display: flex; flex-direction: row;"  >
          <span  style="align-self: center;min-width: 102px;">Click pencil, then specific Point in image to Create Crack End Point then confirm with tick box</span>
     
          <a (click)="ClearCurrentEndXY()"><i class="material-icons square-button__icon">edit</i></a>
          <mat-form-field style="width: 20%;">
            <input matInput type="text"[(ngModel)]="endXY"  #noOfReading_="ngModel" [disabled]="true">
          </mat-form-field>
          <a *ngIf="isEndEdit==false"><i class="material-icons square-button__icon"  title="Confirm Ending Point">check_box</i></a>
          <a *ngIf="isEndEdit==true"(click)="ConfirmEndXY()"><i class="material-icons square-button__icon"  title="Confirm Starting Point" style="cursor: pointer;">check_box_outline_blank</i></a>
        </div>
  </ng-container>
  </ng-container>      
  
        <div class="ttmodal__footer">
          <a class="button margin-right-8" (click)="onCloseClick()"><span class="button__text">Cancel</span></a>
          <a class="button button--primary" (click)="editObservation()"><span class="button__text">Save Changes</span></a>
        </div>
      </div>
    </div>
  </div>
          <!-- <add-observation-point *ngIf="showAddObservation" [(cusID)]="CustomerId" [(implementID)]="ImplementId" [(showOPWindow)]="showAddObservation" (closeObservationWindow)="onCloseObservationWindow($event)"
              [(positionX)]="eventX" [(positionY)]="eventY" [(schematicID)]="schematic" style="width:600px;" [class.nodisplay]="!showAddObservation"> </add-observation-point> -->

          <div class="ttmodal" id="schematicWindow">
              <div id="schematicWindowHeader" class="ttmodal__header">
                  <span class="ttmodal__title">{{title}}</span>
                  <div class="panel__header__button-container" id="closeButton">
                   
                      <a class="button waves-effect" (click)="onCloseClick()">
                          <i class="material-icons button__icon">cancel</i>
                          <span class="button__text">Close</span> 
                      </a>
                  </div>
              </div>

              <div class="ttmodal__body">
                  <div *ngIf="schematic.Data != null" style="width: auto; height: auto; position: relative; margin-left: 2px;">
                      <img [src]="getImage(schematic.Data)"  style="width:640px; height: 100%;" 
                          (click)="openObservationPointModal($event);ConfirmStartXY();ConfirmEndXY() " >
                      <ng-container *ngIf="schematic.ObservationPoints != null">
                          
                            <ng-container *ngFor="let cp of findEditObsPoint">
                              <i class="material-icons button__icon component-dot" [class.green-eval]="getEval(cp.WornPct, cp.InspectionDate) == 'green'"
                                  [class.yellow-eval]="getEval(cp.WornPct, cp.InspectionDate) == 'yellow'"
                                  [class.orange-eval]="getEval(cp.WornPct, cp.InspectionDate) == 'orange'"
                                  [class.default]="getEval(cp.WornPct, cp.InspectionDate) == 'magenta' || cp.ObservationType == 'Crack' ||cp.ObservationType == 'Normal'" [class.no-eval]="getEval(cp.WornPct, cp.InspectionDate) == 'gray' ||cp.ObservationType == 'Crack' ||cp.ObservationType == 'Normal'"
                                 
                                  [class.component-dot2]="mouseoverOPId == cp.Id" (mouseover)="onMouseOverOP(cp.Id)"
                                  (mouseout)="onMouseOutOP(cp.Id)" matTooltip="{{cp.Name}} ({{cp.WornPct}}% Worn) Last Inspection - {{cp.InspectionDate}}"
                                  [style]="getPosition(cp.PositionX, cp.PositionY)" >lens</i>
                                 
                            <!-- <ng-container *ngIf="cp.ObservationType == 'Crack'"> -->
                              <i class="material-icons button__icon component-dot2"  style="line-height: 0; " *ngIf="cp.PositionYEnd!=null"
                                  matTooltip={{cp.Name}}  (click)="SelectObPoint(cp)"
                                  [class.default]="getEval(cp.WornPct, cp.InspectionDate) == 'magenta' ||cp.ObservationType == 'Crack' ||cp.ObservationType == 'Normal' "
                                  [class.no-eval]="getEval(cp.WornPct, cp.InspectionDate) == 'gray' ||cp.ObservationType == 'Crack' ||cp.ObservationType == 'Normal'"
                                  [class.green-eval]="getEval(cp.WornPct, cp.InspectionDate) == 'green'"     
                                     
                                  [style]="getPosition(cp.PositionXEnd, cp.PositionYEnd)"> lens</i>
                            <!-- </ng-container> -->

                            <div *ngIf="cp.PositionYEnd!=null"  [style]="getLine(cp.PositionX, cp.PositionY,cp.PositionXEnd, cp.PositionYEnd,cp.isCrackFixed)"></div>
                          </ng-container>
                            

                          <ng-container *ngFor="let rest of findRestObsPoint">
                            <i class="material-icons button__icon component-dot" [class.green-eval]="getEvalEdit(rest.WornPct, rest.InspectionDate) == 'green'"
                                [class.yellow-eval]="getEvalEdit(rest.WornPct, rest.InspectionDate) == 'yellow'"
                                [class.orange-eval]="getEvalEdit(rest.WornPct, rest.InspectionDate) == 'orange'"
                                [class.defaultEdit]="getEvalEdit(rest.WornPct, rest.InspectionDate) == 'green' || rest.ObservationType == 'Crack' ||rest.ObservationType == 'Normal'" [class.no-eval]="getEvalEdit(rest.WornPct, rest.InspectionDate) == 'gray' ||rest.ObservationType == 'Crack' ||rest.ObservationType == 'Normal'"
                               
                                [class.component-dot2]="mouseoverOPId == rest.Id" (mouseover)="onMouseOverOP(rest.Id)"
                                (mouseout)="onMouseOutOP(rest.Id)" matTooltip="{{rest.Name}} ({{rest.WornPct}}% Worn) Last Inspection - {{rest.InspectionDate}}"
                                [style]="getPosition(rest.PositionX, rest.PositionY)" >lens</i>
                               
                          <!-- <ng-container *ngIf="rest.ObservationType == 'Crack'"> -->
                            <i class="material-icons button__icon component-dot2"  style="line-height: 0; " *ngIf="rest.PositionYEnd!=null"
                                matTooltip={{rest.Name}}  (click)="SelectObPoint(rest)"
                                [class.defaultEdit]="getEvalEdit(rest.WornPct, rest.InspectionDate) == 'green' ||rest.ObservationType == 'Crack' ||rest.ObservationType == 'Normal' "
                                [class.no-eval]="getEvalEdit(rest.WornPct, rest.InspectionDate) == 'gray' ||rest.ObservationType == 'Crack' ||rest.ObservationType == 'Normal'"
                                [class.green-eval]="getEvalEdit(rest.WornPct, rest.InspectionDate) == 'green'"     
                                   
                                [style]="getPosition(rest.PositionXEnd, rest.PositionYEnd)"> lens</i>
                          <!-- </ng-container> -->

                          <div *ngIf="rest.PositionYEnd!=null"  [style]="getLine(rest.PositionX, rest.PositionY,rest.PositionXEnd, rest.PositionYEnd,rest.isCrackFixed)"></div>
                        </ng-container>

                      </ng-container>
                  </div>
              </div>
          </div>
      </div>


  </div>
</div>